export const getRandomId = (): string => {
  return Math.random().toString(36).substring(2);
};

export const getRandomInt = (min: number = 1, max: number = 10000): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
